<!--This is where we render our navigation stack-->
<router-outlet></router-outlet>
